import { CSSProperties, MouseEvent } from 'react';
import styled from 'styled-components';
import Icon from '../Icon';
import { MenuContext } from './Menu';

export interface MenuOptionProps {
    value?: any;
    children: any;
    style?: CSSProperties;
    icon?: string;
    onClick?: (event?: MouseEvent) => void;
}

export default function MenuOption({ value, children, icon, onClick, style }: MenuOptionProps) {
    return (
        <MenuContext.Consumer>
            {({ test, callback }) =>
                <Wrapper style={style} onClick={(e) => { callback(value); onClick && onClick(e) }} tabIndex={1}>
                    {icon ?
                        <>
                            <Icon className='menu-option-icon' icon={icon}></Icon>
                            <div className='menu-option-title'>{children}</div>
                        </>
                        : children}
                </Wrapper>}
        </MenuContext.Consumer>

    )
}

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    padding: 0 20px;

    cursor: pointer;
    user-select: none;
    
    transition: background-color 0.1s;

    /* .menu-option-icon { color: #ffffff; } */
    .menu-option-title { padding-left: 20px; }

    &:hover {
        background-color: #ffffff22;
        /* background-color: #00000022; */
    }
`